import { TranslatePipe } from '../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { PreVisitCardComponent } from '../../../components/pre-visit/card/pre-visit-card.component';
import { ItemNotificationComponent } from '../../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Config from '../../../utils/config.service';
import BusinessRestServices from '../../../services/business-rest.service';
import Session from '../../../utils/session.service';
import UserService from '../../../services/user.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import DialogServices from '../../../services/dialog.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';
import { ModalUpdateUserComponent } from '../../../components/pre-visit/record-ticket-for-person/modal-update-user/modal-update-user.component';

@Component({
	standalone: true,
	selector: 'pre-visit-card-list',
	templateUrl: './pre-visit-card-list.component.html',
	imports: [
		CommonModule, TranslatePipe, LoaderOverlayComponent, PreVisitCardComponent, 
		ItemNotificationComponent, FormsModule, RouterLink
	]
})
export default class PreVisitCardListComponent implements OnInit {
	private config: Config = inject(Config);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private userService: UserService = inject(UserService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.loading = true;
		
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.previsitLocation = true;
		}
		this.vm.websiteImageSuffix = this.vm.previsitLocation ? '-previsit' : '';
		this.vm.websiteLinkColor = this.vm.previsitLocation ? '#26009d' : 'white';
		
		this.routingService.validateAccess('preVisitDashboard').then(() => {
			this.loadConfig();
		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	loadConfig() {
		var rawData: any = window.sessionStorage.getItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
		var booking: any = rawData ? JSON.parse(rawData) : {};
		var origin: any = this.angularRoutingHelperService.getQueryParam('origin');
		if (!origin) {
			origin = 'minudoc.ee';
		}
		
//		if (booking && booking.service) {
//			this.onResolve();
//		} else {
		var params: any = {
			origin: origin
		};
		this.businessRestServices.getOnDemandSettings(params, (settings) => {
			this.vm.settings = settings;
			this.onResolve();
		});
//		}
	}
	
	onResolve() {
		this.vm.isInsuredOrNotified = true;
		this.vm.isRecordTicketForPerson = false;
		this.vm.businessService = {};
		
		this.loadInsuranceData();
	}
	
	completeInit() {
		this.vm.user = this.preVisitRecordTicketForPersonService.getPatient()
			? this.preVisitRecordTicketForPersonService.getPatient().user
			: this.session.getSession().user;
		this.vm.doctorName = this.vm.insuranceData?.doctorName;
		this.vm.doctorWebsite = this.vm.insuranceData?.businessService ? this.vm.insuranceData.businessService.websiteUrl : null;
		this.vm.isInsuredOrNotified = window.sessionStorage.getItem("PreVisitPatientInformedOfUninsured")
			? true
			: this.vm.insuranceData?.insured;
		this.vm.userPatientListCode = this.vm.insuranceData?.doctorPatientListing;
		this.vm.businessService = this.vm.insuranceData?.businessService;
		
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.vm.parentCategory = this.vm.params['parentCategory'];
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		this.watcher = this.angularHelperService.createInterval(() => {
			var newParentCategory = this.angularRoutingHelperService.getQueryParams()['parentCategory'];
			if (this.vm.parentCategory !== newParentCategory) {
				this.vm.parentCategory = newParentCategory;
				this.vm.loading = true;
				this.loadConfig();
			}
		}, 300);
		
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		this.vm.secondPersonWarningMain = this.angularFilterHelperService.translate('PreVisit.Card_List.Second_Person_Warning_Main');
		this.vm.secondPersonWarningLeft = this.angularFilterHelperService.translate('PreVisit.Card_List.Second_Person_Warning_Left');
		this.vm.sessionUser = this.session.getSession().user;
		if (this.vm.sessionUser.previsitUser) {
			this.vm.hideBackButton = true;
		}
		this.vm.isRegistrator = this.vm.sessionUser.businessUserType && this.vm.sessionUser.businessUserType == 'SERVICE_PROVIDER';
		
		var services: any = {};
		var HEALTHY_PATIENT: any = 'HEALTHY_PATIENT_VISIT';
		var followUpEnabled = this.vm.insuranceData?.settings?.followUpEnabled;
		var mentalHealthEnabled = this.vm.insuranceData?.preVisitMentalHealthConfig == 'ACTIVE';
		var sickLeaveCertificateEnabled = this.vm.insuranceData?.settings?.sickLeaveCertificateEnabled;
		if (this.vm.parentCategory === HEALTHY_PATIENT && this.vm.isRecordTicketForPerson) {
			services.types = [
				'HEALTH_CERTIFICATE_REQUEST',
				'HEALTH_CHECKUP_REQUEST',
				'VACCINATION_REQUEST',
				'NEW_PRESCRIPTION_REQUEST',
				'CHILD_RELATED_REQUEST'
			];
		} else if (this.vm.parentCategory === HEALTHY_PATIENT) {
			services.types = [
				'HEALTH_CERTIFICATE_REQUEST',
				'HEALTH_CHECKUP_REQUEST',
				'VACCINATION_REQUEST',
				'NEW_PRESCRIPTION_REQUEST'
			];
		} else if (this.vm.isRecordTicketForPerson) {
			services.types = [];
			services.types.push('NEW_HEALTH_PROBLEM');
			services.types.push('PRESCRIPTION_RENEW_REQUEST');
			if (sickLeaveCertificateEnabled) {
				services.types.push('SICK_LEAVE_CERTIFICATE_REQUEST');
			}
			if (followUpEnabled) {
				services.types.push('FOLLOW_UP_REQUEST');
			}
			services.types.push(HEALTHY_PATIENT);
			services.types.push('CHRONICALLY_ILL_VISIT_REQUEST');
		} else {
			services.types = [];
			services.types.push('NEW_HEALTH_PROBLEM');
			services.types.push('PRESCRIPTION_RENEW_REQUEST');
			if (sickLeaveCertificateEnabled) {
				services.types.push('SICK_LEAVE_CERTIFICATE_REQUEST');
			}
			if (followUpEnabled) {
				services.types.push('FOLLOW_UP_REQUEST');
			}
			services.types.push(HEALTHY_PATIENT);
			services.types.push('CHRONICALLY_ILL_VISIT_REQUEST');
			if (mentalHealthEnabled) {
				services.types.push('MENTAL_HEALTH');
			}
		}
		this.vm.cantUseServiceReasons = {
			'NO_ID_CODE': this.angularFilterHelperService.translate('PreVisit.Card_List.No_Estonian_Id_Code'),
			'TECHNICAL_ISSUE': this.angularFilterHelperService.translate('PreVisit.Card_List.Technical_Issue'),
			'DOCTOR_NOT_JOINED': this.angularFilterHelperService.translate('PreVisit.Card_List.Doctor_Not_Joined'),
			'NO_ACTIVE_EHIF_INSURANCE': this.angularFilterHelperService.translate('PreVisit.Card_List.No_Active_EHIF_Insurance'),
			'NOT_PART_OF_ANY_PATIENT_LISTING': this.angularFilterHelperService.translate('PreVisit.Card_List.Not_Part_Of_Any_Patient_Listing'),
			'DOCTOR_JOINED_BUT_PRE_VISIT_DISABLED': this.angularFilterHelperService.translate('PreVisit.Card_List.Doctor_Joined_But_Pre_Visit_Disabled'),
			'CONSENT_SERVICE_MINORS_NOT_SUPPORTED': this.angularFilterHelperService.translate('XRoadConsentService.Error_Minor')
		};
		this.vm.services = services;
		this.vm.cantUseServiceReason = this.cantUseServiceReasonPicker();
		if (this.vm.cantUseServiceReason == 'redirecting') {
			return;
		}
		this.handleAvailableServicesCountUpdate(this.vm.services.types.length);
		this.vm.setPatientInformedOfUninsured = this.setPatientInformedOfUninsured;
		this.vm.clearRecordTicketForPatientData = this.clearRecordTicketForPatientData;
		this.vm.updatePatientPersonalDetails = this.updatePatientPersonalDetails;
		
		this.vm.loading = false;
	}
	
	loadInsuranceData() {
		if (!!this.preVisitRecordTicketForPersonService.getPatient()) {
			this.vm.insuranceData = this.preVisitRecordTicketForPersonService.getPatient();
			this.vm.hasOtherPersonActivated = true;
			this.completeInit();
			return;
		} else {
			this.vm.hasOtherPersonActivated = false;
		}
		this.userService.getUserInsuranceData().then((insuranceData) => {
			this.vm.insuranceData = insuranceData;
			var settings: any = insuranceData?.settings;
			if (settings) {
				settings.insured = insuranceData.insured;
				settings.businessService = insuranceData.businessService;
				settings.preVisitMentalHealthConfig = insuranceData.preVisitMentalHealthConfig;
				settings.preVisitNewHealthProblemConfig = insuranceData.preVisitNewHealthProblemConfig;
				this.preVisitRecordTicketForPersonService.setSettings(settings);
			}
			this.completeInit();
		});
	}
	
	handleAvailableServicesCountUpdate(count) {
		switch (count) {
			case 3:
			case 5:
			case 6:
				this.vm.isNarrow = true;
				break;
			default:
				this.vm.isNarrow = false;
		}
	}
	
	cantUseServiceReasonPicker() {
		if (this.vm.insuranceData.errorCode === 'CONSENT_NOT_GIVEN_TO_INSURANCE_DATA') {
			if (this.vm.sessionUser.id === this.vm.user.id && this.vm.sessionUser.businessUserType === 'SERVICE_PROVIDER') {
				this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
			} else {
				this.angularRoutingHelperService.setPath('/xroad/consents', false, false, { comingFrom: 'pre-visit' });
			}
			return 'redirecting';
		} else if (this.vm.insuranceData.errorCode === 'XROAD_CONSENT_NOT_GIVEN_TO_INSURANCE_DATA') {
			if (this.vm.sessionUser.id === this.vm.user.id && this.vm.sessionUser.businessUserType === 'SERVICE_PROVIDER') {
				this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
			} else {
				this.angularRoutingHelperService.setPath('/xroad/consent-service', false, false, { comingFrom: 'pre-visit' });
			}
			return 'redirecting';
		} else if (this.vm.insuranceData.errorCode === 'NO_MISP_SESSION') {
			this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
		} else if (this.vm.insuranceData.errorCode === 'ERROR_XROAD_CONSENTS_ACCESS_FOR_MINOR') {
			return this.vm.cantUseServiceReasons['CONSENT_SERVICE_MINORS_NOT_SUPPORTED'];
		} else if (this.vm.insuranceData.errorCode === 'NO_ID_CODE') {
			return this.vm.cantUseServiceReasons['NO_ID_CODE'];
		} else if (this.vm.insuranceData.errorCode) {
			return this.vm.cantUseServiceReasons['TECHNICAL_ISSUE'];
		} else if (!this.vm.businessService && this.vm.isInsuredOrNotified) {
			return this.vm.cantUseServiceReasons['DOCTOR_NOT_JOINED'];
		} else if (!this.vm.isInsuredOrNotified && this.vm.businessService && this.vm.businessService.preVisitEnabled) {
			return this.vm.cantUseServiceReasons['NO_ACTIVE_EHIF_INSURANCE'];
		} else if (!this.vm.isInsuredOrNotified && !this.vm.businessService && this.vm.userPatientListCode) {
			return this.vm.cantUseServiceReasons['DOCTOR_NOT_JOINED'];
		} else if (!this.vm.isInsuredOrNotified && !this.vm.userPatientListCode) {
			return this.vm.cantUseServiceReasons['NOT_PART_OF_ANY_PATIENT_LISTING'];
		} else if (this.vm.businessService && !this.vm.businessService.preVisitEnabled) {
			return this.vm.cantUseServiceReasons['DOCTOR_JOINED_BUT_PRE_VISIT_DISABLED'];
		}
		return '';
	}
	
	setPatientInformedOfUninsured() {
		this.vm.isInsuredOrNotified = true;
		window.sessionStorage.setItem("PreVisitPatientInformedOfUninsured", "true");
	}
	
	clearRecordTicketForPatientData() {
		this.preVisitRecordTicketForPersonService.clearData();
		this.angularRoutingHelperService.clearQueryParamsDirty()
		this.angularRoutingHelperService.setPath('/');
	}
	
	goToInsertForPersonList() {
		this.preVisitRecordTicketForPersonService.clearData(null, true);
		this.angularRoutingHelperService.setPath('/pre-visit/insert-for-person-list');
	}
	
	clearPreVisitData() {
		this.preVisitRecordTicketForPersonService.clearData();
		this.angularRoutingHelperService.setPath('');
	}
	
	updatePatientPersonalDetails() {
		var dialog = this.dialogServices.show({
			controller: ModalUpdateUserComponent,
			userEstonianIdentificationCode: this.vm.user.personalCode,
			isPatient: !this.vm.isRegistrator
		});
		dialog.afterClosed().subscribe(
			(user) => {
				if (user) {
					this.vm.user.firstname = user.firstname;
					this.vm.user.lastname = user.lastname;
				}
			},
			() => {
				// show warning?
			}
		);
	}
	
}